import { motion } from "framer-motion";

const LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/wingman/6a2d24da-fe6b-45e8-b3f6-39d1323c9726/attachments/b8c6d2faf53e4b229e83e258b921f0cf_icon.png";

export default function Header() {
  return (
    <>
      <header
        data-testid="site-header"
        className="fixed inset-x-0 top-0 z-50 border-b border-[#e2e8f0]/70 bg-white/85 backdrop-blur-xl"
      >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:h-20 sm:px-6 lg:px-8">
        <a
          href="#top"
          data-testid="header-brand-link"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO}
            alt="EduAlert logo"
            data-testid="header-logo-image"
            className="h-10 w-10 rounded-xl shadow-md shadow-[#1a237e]/15"
          />
          <span>
            <span
              data-testid="header-brand-name"
              className="font-display block text-xl font-extrabold leading-none text-[#1a237e]"
            >
              EduAlert
            </span>
            <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500 md:hidden">
              Never Miss an Important Update
            </span>
          </span>
        </a>
        <span
          data-testid="header-tagline"
          className="hidden border-l border-slate-200 pl-4 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 md:block"
        >
          Never Miss an Important Update
        </span>
        <a
          href="#join"
          data-testid="header-join-button"
          className="btn-lift hidden items-center rounded-full bg-[#f57c00] px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-[#f57c00]/30 hover:bg-[#e65100] sm:inline-flex"
        >
          Become a Partner
        </a>
      </div>
      </header>
      <a
        href="#join"
        data-testid="mobile-join-sticky-button"
        className="btn-lift fixed inset-x-4 bottom-4 z-50 flex items-center justify-center gap-2 rounded-full bg-[#f57c00] px-6 py-3.5 text-sm font-bold text-white shadow-2xl shadow-[#f57c00]/40 hover:bg-[#e65100] sm:hidden"
      >
        Become a Partner
      </a>
    </>
  );
}